// Comments and interactions dictionary
const dictComments = {
    // Comments main
    comments: {
        th: "ความคิดเห็น",
        en: "Comments",
        ja: "コメント",
    },
    add_comment: {
        th: "ความคิดเห็น",
        en: "Comment",
        ja: "コメント",
    },
    no_comments: {
        th: "ยังไม่มีความคิดเห็น เป็นคนแรกที่แสดงความคิดเห็นสิ",
        en: "No comments yet. Be the first to share your thoughts!",
        ja: "まだコメントがありません。最初にコメントを投稿してください！",
    },

    // Comment actions
    reply: {
        th: "ตอบกลับ",
        en: "Reply",
        ja: "返信",
    },
    edit: {
        th: "แก้ไข",
        en: "Edit",
        ja: "編集",
    },

    // Comment errors and confirmations
    comments_delete_confirm: {
        th: "คุณแน่ใจหรือไม่ว่าต้องการลบความคิดเห็นนี้?",
        en: "Are you sure you want to delete this comment?",
        ja: "このコメントを削除してもよろしいですか？",
    },
    comments_enter_content: {
        th: "กรุณาใส่เนื้อหาความคิดเห็น",
        en: "Please enter comment content",
        ja: "コメント内容を入力してください",
    },
    comments_network_error: {
        th: "เกิดข้อผิดพลาดเครือข่าย กรุณาลองใหม่อีกครั้ง",
        en: "Network error occurred. Please try again.",
        ja: "ネットワークエラーが発生しました。再試行してください。",
    },
    comments_delete_error: {
        th: "ไม่สามารถลบความคิดเห็นได้ กรุณาลองใหม่อีกครั้ง",
        en: "Unable to delete comment. Please try again.",
        ja: "コメントを削除できませんでした。再試行してください。",
    },
    comments_edit_error: {
        th: "ไม่สามารถแก้ไขความคิดเห็นได้ กรุณาลองใหม่อีกครั้ง",
        en: "Unable to edit comment. Please try again.",
        ja: "コメントを編集できませんでした。再試行してください。",
    },
    comments_reply_error: {
        th: "ไม่สามารถส่งการตอบกลับได้ กรุณาลองใหม่อีกครั้ง",
        en: "Unable to send reply. Please try again.",
        ja: "返信を送信できませんでした。再試行してください。",
    },
    comments_generic_error: {
        th: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
        en: "An error occurred. Please try again.",
        ja: "エラーが発生しました。再試行してください。",
    },
    comment_posted: {
        th: "โพสต์ความคิดเห็นเรียบร้อยแล้ว!",
        en: "Comment posted successfully!",
        ja: "コメントを投稿しました！",
    },
    comment_deleted: {
        th: "ลบความคิดเห็นเรียบร้อยแล้ว",
        en: "Comment deleted successfully",
        ja: "コメントを削除しました",
    },
    comment_updated: {
        th: "อัปเดตคอมเมนต์เรียบร้อยแล้ว!",
        en: "Comment updated successfully!",
        ja: "コメントを更新しました！",
    },
    comments_post_error: {
        th: "ไม่สามารถโพสต์ความคิดเห็นได้",
        en: "Failed to post comment",
        ja: "コメントを投稿できませんでした",
    },
    comments_confirm: {
        th: "ยืนยัน",
        en: "Confirm",
        ja: "確認",
    },
    comments_cancel: {
        th: "ยกเลิก",
        en: "Cancel",
        ja: "キャンセル",
    },

    // Common form actions
    save: {
        th: "บันทึก",
        en: "Save",
        ja: "保存",
    },
    cancel: {
        th: "ยกเลิก",
        en: "Cancel",
        ja: "キャンセル",
    },

    // User information
    male: {
        th: "ชาย",
        en: "Male",
        ja: "男性",
    },
    female: {
        th: "หญิง",
        en: "Female",
        ja: "女性",
    },
    age_unit: {
        th: "ปี",
        en: "yrs",
        ja: "歳",
    },

    // Images and attachments
    attached_images: {
        th: "รูปภาพแนบ",
        en: "Attached Images",
        ja: "添付画像",
    },

    // Read count
    read_count: {
        th: "จำนวนผู้อ่าน",
        en: "Read Count",
        ja: "閲覧数",
    },

    // Placeholders
    comment_placeholder: {
        th: "แสดงความคิดเห็นของคุณที่นี่...",
        en: "Share your thoughts here...",
        ja: "ここにコメントを入力...",
    },
    edit_content_placeholder: {
        th: "เนื้อหาใหม่...",
        en: "New content...",
        ja: "新しい内容...",
    },
    reply_placeholder: {
        th: "พิมพ์ข้อความตอบกลับ...",
        en: "Type your reply...",
        ja: "返信を入力...",
    },

    // Interaction elements
    likes: {
        th: "ถูกใจ",
        en: "Likes",
        ja: "いいね",
    },
    views: {
        th: "การดู",
        en: "Views",
        ja: "閲覧数",
    },
    share: {
        th: "แชร์",
        en: "Share",
        ja: "シェア",
    },
    report: {
        th: "รายงาน",
        en: "Report",
        ja: "報告",
    },
    bookmark: {
        th: "บุ๊กมาร์ก",
        en: "Bookmark",
        ja: "ブックマーク",
    },

    // Auth messages for interactions
    auth_required_like_message: {
        th: "ต้องเข้าสู่ระบบก่อนกดไลก์",
        en: "Please log in to like posts",
        ja: "いいねをするにはログインが必要です",
    },
    comment_login_required: {
        th: "ในการแสดงความคิดเห็นต้อง",
        en: "Login required to comment:",
        ja: "コメントするにはログインが必要です:",
    },
};

export { dictComments };
